var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-slide-y-reverse-transition',[_c('router-view'),_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }